import { useEffect, useRef, useState } from "react";
import type { PlanPreview } from "../../../shared/labels/contracts";
import { uiFault, type LabelsApi } from "./labels-api";

export function usePreparedPlanWorkspace(api: LabelsApi, scopeKey: string) {
  const [catalog, setCatalog] = useState<Awaited<ReturnType<LabelsApi["preparedPlanSources"]>> | null>(null);
  const [loading, setLoading] = useState(true);
  const [fault, setFault] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState<PlanPreview | null>(null);
  const [reload, setReload] = useState(0);
  const key = useRef<string | null>(null);
  const busyRef = useRef(false);
  const mutation = useRef<AbortController | null>(null);
  useEffect(() => {
    const controller = new AbortController(); setLoading(true); setFault(null); setCatalog(null);
    void api.preparedPlanSources(controller.signal).then(data => { if (!controller.signal.aborted) setCatalog(data); })
      .catch((error: unknown) => { if (!controller.signal.aborted) setFault(uiFault(error).message); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [api, scopeKey, reload]);
  useEffect(() => { setPreview(null); setBusy(false); key.current = null; return () => { mutation.current?.abort(); busyRef.current = false; }; }, [api, scopeKey]);
  async function save() {
    if (busyRef.current || !catalog?.items.some(item => item.key === "2026-week-45")) return;
    busyRef.current = true; setBusy(true); setFault(null); key.current ??= crypto.randomUUID();
    const controller = new AbortController(); mutation.current = controller;
    try {
      const data = await api.savePreparedPlanSource("2026-week-45", key.current, controller.signal);
      if (!controller.signal.aborted) { setPreview(data); setReload(value => value + 1); }
    } catch (error: unknown) { if (!controller.signal.aborted) setFault(uiFault(error).message); }
    finally { if (!controller.signal.aborted) { busyRef.current = false; setBusy(false); } }
  }
  return { catalog, loading, fault, busy, preview, save, retry: () => setReload(value => value + 1) };
}
